export const flightBookingHeaders = [
  { columnName: 'From City', required: true },
  { columnName: 'To Country', required: true },
  { columnName: 'To City', required: true },
  { columnName: 'Date', required: true },
  { columnName: 'Dept. Time', required: true },
  { columnName: 'Airline', required: true },
  { columnName: 'Class', required: true },
  { columnName: 'Traveller', required: false },
];
